import Check from './icons/Check';
import Clock from './icons/Clock';
import Question from './icons/Question';
import SkillCompleting from './icons/SkillCompleting';

const TeacherDiagnosticPrepDiagnosticQuickFacts: React.FC = () => {
  return (
    <div className="tw-pb-8 tw-border-b-[2px] tw-border-t-[0px] tw-border-x-[0px] tw-border-neutral-100 tw-border-solid">
      <p className="tw-font-sora tw-text-neutral-950 tw-text-sm tw-font-bold">QUICK FACTS</p>
      <span className="nc_prep-diagnostic-quick-facts">
        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
          <Check />
          <h1>Automatically assigned</h1>
          <p>The diagnostic is ready for your class, no action needed</p>
        </div>
        <span className="tw-w-[2px] tw-h-[88px] tw-bg-neutral-300"></span>
        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
          <Clock />
          <h1>About 45–60 mins</h1>
          <p>Students can pause anytime and resume where they leave off</p>
        </div>
        <span className="tw-w-[2px] tw-h-[88px] tw-bg-neutral-300"></span>

        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
          <Question />
          <h1>~34 questions</h1>
          <p>Adapts to each student, above and below grade level</p>
        </div>
        <span className="tw-w-[2px] tw-h-[88px] tw-bg-neutral-300"></span>

        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
          <SkillCompleting />
          <h1>Work shown on paper</h1>
          <p>Students should work problems out by hand</p>
        </div>
      </span>
    </div>
  );
};

export default TeacherDiagnosticPrepDiagnosticQuickFacts;
